import { useFormContext } from "react-hook-form";
import { FieldSetInputProps, FieldButton } from "components/voc";
import styled from "styled-components";
import IconSelect from "assets/images/icon_select.png";

const HiddenStyled = styled.input`
  display: block;
  width: 100%;
  padding: 1.4rem 1.6rem;
  border: 1px solid #a8b2ba;
  border-radius: 0.8rem;
  font-family: "Pretendard", sans-serif;

  ::-moz-placeholder {
    color: #c9c9c9;
  }

  ::placeholder {
    color: #c9c9c9;
  }

  &.btn_bottomsheet {
    position: relative;
    padding: 1.4rem 5rem 1.4rem 1.6rem;
    border: 1px solid #a8b2ba;
    border-radius: 0.8rem;
    font-family: "Pretendard", sans-serif;
    color: #000;
    text-align: left;
  }

  &.btn_bottomsheet::after {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    width: 1.8rem;
    height: 1.8rem;
    margin-top: -0.9rem;
    background: url(${IconSelect}) no-repeat center;
    background-size: 1.8rem;
    content: "12";
  }

  &.btn_bottomsheet.-data {
    color: #000;
  }
`;

type FieldHiddenProps = FieldSetInputProps;

const FieldHidden = ({ name, hiddenType, hiddenFunction, ...props }: FieldHiddenProps) => {
  const { register } = useFormContext();

  return (
    <>
      <HiddenStyled {...register(name!)} {...props} />
      {props.value && hiddenType === "time" && (
        <>
          <ul className="list_time">
            {[...(props.value as string[])].map((el, idx) => (
              <li key={idx}>{el}시</li>
            ))}
          </ul>
          <FieldButton type="button" className="btn_select_bottomsheet btn_solid" onClick={hiddenFunction}>
            재선택
          </FieldButton>
        </>
      )}
    </>
  );
};

export default FieldHidden;
